export const ADD_BUSES = "ADD_BUSES";
export const FETCH_BOOKING_BYROUTE = "FETCH_BOOKING_BYROUTE";
export const ADD_NEW_BOOKING = "ADD_NEW_BOOKING";
export const ADD_BOARDING_POINT = "ADD_BOARDING_POINT";
export const ADD_DROPPING_POINT = "ADD_DROPPING_POINT";
export const ADD_JOURNEY_DETAILS_BOOKING = "ADD_JOURNEY_DETAILS_BOOKING";
export const REMOVE_SEATS = "REMOVE_SEATS";
export const USER_LOGGED_IN = "USER_LOGGED_IN";
export const USER_LOGGED_OUT = "USER_LOGGED_OUT";
export const CLEAR_BOOKING_STATE = "CLEAR_BOOKING_STATE";
export const ADD_NEW_SEAT_TO_ARRAY = "ADD_NEW_SEAT_TO_ARRAY";
export const ADD_EMAIL_MOBILE = "ADD_EMAIL_MOBILE"
export const UPDATE_SEAT_WITH_PERSON_DETAILS='UPDATE_SEAT_WITH_PERSON_DETAILS'